import * as Yup from "yup";
export const ApolloSchema = Yup.object({
    GRAPHQL_URL: Yup.string().required(),
});
export function getApolloConfig(env) {
    return {
        GRAPHQL_URL: env.REACT_APP_GRAPHQL_URL,
    };
}
//# sourceMappingURL=apollo.js.map